import React from 'react';
import { Box, useTheme } from '@mui/material';
import { DynamicForm } from './DynamicForm';
import { logo } from '@frontend/assets';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export const SupportForm: React.FC<{
  title: string;
  description: string;
  agencyId: string;
  workflowId: string;
  customLogoUrl?: string;
  editing?: boolean;
}> = ({ title, description, customLogoUrl, editing, agencyId, workflowId }) => {
  const theme = useTheme();
  return (
    <Box display="flex" position="relative" minHeight="100vh">
      <Box
        sx={{
          width: '60%',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          padding: theme.spacing(3),
        }}
      >
        <Box
          sx={{
            '.ck-content': {
              ...theme.typography.body2,
            },
            '.ck-editor__editable': {
              borderColor: 'transparent !important',
              backgroundColor: 'transparent !important',
            },
            '.ck-reset_all': {
              display: 'none',
            },
          }}
        >
          <CKEditor
            editor={ClassicEditor}
            data={description}
            disabled
            config={{
              toolbar: [],
            }}
          />
        </Box>
        <Box my={theme.spacing(8)}>
          <img
            src={customLogoUrl || logo}
            style={{
              maxHeight: '100px',
              maxWidth: '100px',
              objectFit: 'scale-down',
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          width: '40%',
          padding: theme.spacing(3),
          borderLeft: `1px solid ${theme.palette.divider}`,
        }}
      >
        <DynamicForm title={title} agencyId={agencyId} workflowId={workflowId} editing={editing} />
      </Box>
    </Box>
  );
};
